export default __webpack_public_path__ + "static/media/collapse.120dcd7b.svg";